module.exports = __webpack_public_path__ + "img/1.c6e39fa8.png";